export default 'icon--speak';